module.exports = __webpack_public_path__ + "img/gh36060-4-36.prt.ef2dacc6.jpg";